import { ErrorLayout } from 'views/components';
import PropTypes from 'prop-types';
import { Text } from './styled';
import { config } from 'config';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { sharedActions } from 'core/Shared';
import { withRouter } from 'react-router-dom';
import React, { Component } from 'react';
const { errorBoundary, environment, version } = config;

class ErrorBoundary extends Component {
    
    static getDerivedStateFromError (error) {
        return {
            error,
            hasError: true
        };
    }

    static propTypes = {
        children: PropTypes.any,
        location: PropTypes.object,
        sendError: PropTypes.func
    };

    constructor (props) {
        super(props);
        this.state = {
            error: {},
            hasError: false
        };
    }

    componentDidCatch (error) {
        if (errorBoundary) {
            const { location: { pathname }, sendError } = this.props;
            const stackMessage = error.stack.split('\n');
            const payload = {
                endpoint: `FE${ pathname } in  v${ version }`,
                frontend: isEmpty(stackMessage) ? '-' : stackMessage.slice(0, 3).join('\n'),
                message: error.message ?? '-',
                title: `FE error detected in ${ environment.toUpperCase() }`
            };
            sendError(payload);
        }
    }

    render () {

        const { error, hasError } = this.state;
        const { children } = this.props;

        if (hasError) {
            return (
                <ErrorLayout
                    code="!"
                    description="Ya hemos recibido una notificación y estamos trabajando para solucionar el problema"
                    title="Ocurrió un error inesperado"
                    onDismiss={ () => this.setState({ hasError: false }) }
                >
                    <Text>
                        { error.message ?? '-' }
                    </Text>
                </ErrorLayout>
            );
        }

        return children;
    }
}

export default connect(null, {
    sendError: sharedActions.sendError
})(withRouter(ErrorBoundary));
